import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { getSubscribers } from 'actions/users/subscribers';

import {
    RaisedButton,
    Table,
    TableRow,
    TableHeader,
    TableHeaderColumn,
    TableRowColumn,
    TableBody,
    IconButton,
    TextField,
    Checkbox,
} from 'material-ui';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import styles from 'styles';

class Subscribers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            search: '',
            onlyCompleted: false,
        };

        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);

        this.keyPress = this.keyPress.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onToggleOnlyCompleted = this.onToggleOnlyCompleted.bind(this);

        this.search = this.search.bind(this);
    }

    search() {
        this._loadData(1);
    }

    keyPress(e) {
        const { search } = this.state;

        if (e.keyCode === 13 && (search.length > 2 || search.length < 40)) {
            this._loadData(1);
        }
    }

    onChange(e, value) {
        this.setState({
            search: value,
        }, () => {
            if (this.state.search === '') {
                this._loadData(1);
            }
        });
    }

    onToggleOnlyCompleted(e, value) {
        this.setState({
            onlyCompleted: value,
        }, () => {
            this._loadData();
        });
    }

    nextPage() {
        this._loadData(this.props.subscribers.next);
    }

    prevPage() {
        this._loadData(this.props.subscribers.previous || 1);
    }

    _loadData(page = this.props.subscribers.page) {
        this.props.getSubscribers({
            page,
            filters: {
                search: this.state.search,
                success: this.state.onlyCompleted,
            }
        });
    }

    changeAmount(amount) {
       let remainderAmount = amount % 100;

       if ((remainderAmount + '').length == 1) {
           remainderAmount = "0" + remainderAmount;
       }

        return (amount / 100 | 0) + '.' + remainderAmount
    }

    componentDidMount() {
        this._loadData(1);
    }

    render() {
        const { subscribers: { data, page, loading } } = this.props;
        const { search, onlyCompleted } = this.state;

        return (
            <div id='sender-page' className='table-page'>
                <div className='container'>
                    <h2>Subscribers list</h2>

                    <div className='paper-block margin-10'>
                        <div className='row'>
                            <div className='col-xs-2 middle-xs' style={{ display: 'flex' }}>
                                <IconButton
                                    iconStyle={styles.navigationLeft}
                                    onClick={this.prevPage}
                                    disabled={!loading}
                                >
                                    <ChevronLeft />
                                </IconButton>

                                <span>Page: {page}</span>

                                <IconButton
                                    iconStyle={styles.navigationRight}
                                    onClick={this.nextPage}
                                    disabled={!loading}
                                >
                                    <ChevronRight />
                                </IconButton>
                            </div>
                            <div className='col-xs-4 middle-xs' style={{display: 'flex'}}>
                                <TextField
                                    hintText='Search by Order ID'
                                    value={search}
                                    onChange={this.onChange}
                                    onKeyDown={this.keyPress}
                                />
                                <div style={{ margin: '0 0 0 20px' }}>
                                    <RaisedButton
                                        label='search'
                                        primary
                                        disabled={search.length <= 2 || search.length >= 40}
                                        onClick={this.search}
                                    />
                                </div>
                            </div>

                            <div className="col-xs-4 middle-xs" style={{ display: 'flex' }}>
                                <Checkbox
                                    label="Only completed"
                                    checked={onlyCompleted}
                                    onCheck={this.onToggleOnlyCompleted}
                                />
                            </div>
                        </div>
                    </div>

                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    User
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Order ID
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Package Type
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Amount
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Amount (USD)
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Completed At
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Added At
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Transaction Code
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>

                        <TableBody displayRowCheckbox={false}>
                            {
                                data.map((item, index) => {
                                    let userBlock = null;
                                    if (item.user) {
                                        const { isRemoved, email } = restoreEmail(item.user.email);
                                        userBlock = (
                                            <React.Fragment>
                                                <span>{((item.user.name || "") + " " + (item.user.surname || "")).trim() || '(no name)'} </span>
                                                <br/>
                                                <span style={{ fontStyle: "italic" }}>{item.user.company && item.user.company.name}</span>
                                                <br/>
                                                { isRemoved && <p style={{ color: "red", margin: 0 }}>Removed</p> }
                                                <a style={{ textDecoration: "none" }} href={`mailto:${email}`}>{email}</a>
                                            </React.Fragment>
                                        );
                                    }
                                    return (<TableRow key={index}>
                                        <TableRowColumn style={{ ...styles.tableHeaderColumnSmallCSS, padding: "5px 5px" }}>
                                            { userBlock }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { item.OrderID ? item.OrderID : '' }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { item.packageType ? item.packageType : '' }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { item.TotalAmount ? `${this.changeAmount(item.TotalAmount)} uah` : '' }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { item.AltTotalAmount ? `${this.changeAmount(item.AltTotalAmount)} usd` : '' }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            <span>{ item.completedAt && moment(item.completedAt).format('DD.MM.YYYY') }</span>
                                            <br/>
                                            <span>{ item.completedAt && moment(item.completedAt).format('hh:mm:ss') }</span>
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            <span>{ item.addedAt && moment(item.addedAt).format('DD.MM.YYYY') }</span>
                                            <br/>
                                            <span>{ item.addedAt && moment(item.addedAt).format('hh:mm:ss') }</span>
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableRowColumnSmallCSS}>
                                            <span>{ item.TranCode }</span>
                                            <br/>
                                            <span>{ item.status }</span>
                                        </TableRowColumn>
                                    </TableRow>);
                                })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ subscribers }) => { return { subscribers }; },
    dispatch => bindActionCreators({ getSubscribers }, dispatch),
)(Subscribers);


function restoreEmail(email) {
    const match = /^removeduser_[a-z0-9]{10}_(.+)$/i.exec(email);

    return {
        isRemoved: !!match,
        email: match ? match[1] : email,
        raw: email,
    };
}



// WEBPACK FOOTER //
// ./app/components/Users/Subscribers/Page.jsx